import { render, staticRenderFns } from "./IndustryCategory.vue?vue&type=template&id=4ce5f979&scoped=true"
import script from "./IndustryCategory.vue?vue&type=script&lang=js"
export * from "./IndustryCategory.vue?vue&type=script&lang=js"
import style0 from "./IndustryCategory.vue?vue&type=style&index=0&id=4ce5f979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5f979",
  null
  
)

export default component.exports